import React from 'react';
import strings from '../../localization';
import TablePage from '../../common/TablePage';
import { withSnackbar } from 'notistack';
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import { Grid } from '@material-ui/core';
import SelectControl from '../../components/controls/SelectControl';
import { getMonths, getYears } from '../../util/DateUtil';
import IconButton from "@material-ui/core/IconButton";
import { generateExpectedIncomeReview } from '../../services/report/ReportService';
import { downloadReport, getDefaultGraveSiteTypes, getGraveSiteTypes } from '../../util/ReviewsUtil';

class ExpectedIncomeReviewList extends TablePage {

  constructor(props) {
    super(props);

    const monthsFrom = getMonths();
    monthsFrom.unshift({ id: -1, name: strings.months.all })

    const monthsTo = getMonths();
    monthsTo.unshift({ id: -1, name: strings.months.all })

    const years = getYears();
    years.unshift({ value: -1, name: strings.years.all })

    const graveSiteTypes = getDefaultGraveSiteTypes();
    graveSiteTypes.unshift({ id: 4, name: strings.years.all })

    this.state = {
      ...this.state,
      showAdd: false,
      showSerach: false,
      data: {
        year: { value: -1 },
        monthFrom: { id: -1 },
        monthTo: { id: -1 },
        graveSiteType: { id: 4 }
      },
      filter: {
        monthsFrom: monthsFrom,
        monthsTo: monthsTo,
        years: years,
        graveSiteTypes: graveSiteTypes
      },
    };
  }

  componentDidMount() {
    this.setState({
      companyId: this.props.auth.user.company.id
    })
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
  }

  getPageHeader() {
    return <h1>{strings.expectedIncomeReview.pageTitle}</h1>
  }

  generateReport() {
    let data = {
      companyId: this.state.companyId,
      monthFrom: this.state.data.monthFrom ? this.state.data.monthFrom.id : 0,
      monthTo: this.state.data.monthTo ? this.state.data.monthTo.id : 0,
      optionType: this.state.data.graveSiteType ? this.state.data.graveSiteType.id : 4,
      year: this.state.data.year ? this.state.data.year.value : 0,
      userId: this.props.auth.user.id
    };
    generateExpectedIncomeReview(data).then(response => {
      if (!response.ok) {
        return;
      }

      this.props.enqueueSnackbar(strings.mainBookOfBuriedList.PDF, { variant: 'success' });
      downloadReport(response, "Ocekivani prihodi " + data.monthFrom + "." + data.year + "-" + data.monthTo + "." + data.year);
    })
  }

  render() {
    return (
      <Grid id='table-page'>
        <div className='header'>
          {this.getPageHeader()}
        </div>
        <div className='review-select'>
          <React.Fragment >
            <SelectControl
              options={this.state.filter.graveSiteTypes}
              selected={this.state.data.graveSiteType}
              onChange={this.changeData}
              label={strings.expectedIncomeReview.graveSiteTypes}
              name={"graveSiteType"}
              nameKey={"name"}
              valueKey={"id"}
            />
            <SelectControl
              options={this.state.filter.years}
              selected={this.state.data.year}
              onChange={this.changeData}
              label={strings.expectedIncomeReview.year}
              name={"year"}
              nameKey={"name"}
              valueKey={"value"}
            />
            <SelectControl
              options={this.state.filter.monthsFrom}
              selected={this.state.data.monthFrom}
              onChange={this.changeData}
              label={strings.expectedIncomeReview.monthFrom}
              name={"monthFrom"}
              nameKey={"name"}
              valueKey={"id"}
            />
            <SelectControl
              options={this.state.filter.monthsTo}
              selected={this.state.data.monthTo}
              onChange={this.changeData}
              label={strings.expectedIncomeReview.monthTo}
              name={"monthTo"}
              nameKey={"name"}
              valueKey={"id"}
            />
          </React.Fragment>
        </div>
        <div className="report-button">
          <IconButton onClick={() => this.generateReport()} disabled={this.state.data.monthFrom.id == -1 || this.state.data.monthTo.id == -1 || this.state.data.year.value == -1}
          >
            {strings.reviserReview.generateReport}
          </IconButton>
        </div>

      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(ExpectedIncomeReviewList)));
